@use '@hevoio/hevo-ui-toolkit/styles/variables' as hevo-toolkit-variables;

.selectDestinationContainer {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
  position: relative;
}

.containerSurface {
  position: relative;
  height: 100%;
  width: 100%;
  overflow: hidden;
  overflow-y: auto;
  background-color:  hevo-toolkit-variables.$surface-bg;
}

.errorMessageContainer {
  position: absolute;
  bottom: 60px;
  z-index:  hevo-toolkit-variables.$zindex-overlay-ctrl;
  background:  hevo-toolkit-variables.$surface-bg;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;

  .errorMessagePane {
    max-width: 1000px;
    width: 100%;
    margin-bottom:  hevo-toolkit-variables.$spacer * 0.75;
  }
}
